import { getData, putData } from '../apiClient';

// get subscribe email list with pagination and search
export const getSubscribeEmailList = async ({ page = 1, limit = 10, search = '' }) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/subscribe-emaillist/get?${queryParams}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get subscribe email list API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

/**
 * Updates the status of a subscriber.
 * 
 * @param {Object} data - Payload containing emailid and new status.
 */
export const updateSubscribeEmailStatus = async ({ data }) => {
    try {
        const result = await putData("/subscribe-emaillist/update-status", data);
        return {
            success: true,
            data: result,
        };
    } catch (error) {
        console.error("Update Subscriber Status API error:", error);
        return {
            success: false,
            error: error.status === 400 ? error.error : error.message,
            status: error.status,
        };
    }
};
